import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {UserLoginService} from '../services/user-login.service';


export const LoginGuard: CanActivateFn = () => {
    const userLoginService = inject(UserLoginService);
    const router = inject(Router);


    if (window.location.hostname.includes(environment.administratorDomain)) {
        return false;
    }

    if (userLoginService.getIsLoggedIn()) {
        console.log("[LoginGuard] user already logged in, redirecting to home");
        router.navigate([environment.baseAppPath + '/home']).then();
        return false;
    }
    return true;
};
